module.exports = __webpack_public_path__ + "static/media/jpge_icon.66de151a.svg";